
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_efqlv_1qglu_5"
};
  